import React from "react";
import { useTranslation } from "react-i18next";
import { computeVatBreakdown, formatMoney } from "./totalsUtil";

/**
 * VatBreakdown — per-rate VAT table (net → VAT amount → gross), computed from the
 * per-item VAT select that previously fed nothing (R14). Display-only.
 */
const VatBreakdown = ({ invoiceData }) => {
  const { t } = useTranslation();
  const { rows, totals } = computeVatBreakdown(invoiceData);

  if (!rows.length) return null;

  return (
    <div className="vat-breakdown">
      <div className="vat-breakdown-title fs14 poppins-medium dark-text">
        {t("vatBreakdown")}
      </div>
      <table className="vat-breakdown-table">
        <thead>
          <tr>
            <th className="vat-breakdown-th text-start">{t("vatRate")}</th>
            <th className="vat-breakdown-th text-end">{t("netAmount")}</th>
            <th className="vat-breakdown-th text-end">{t("vatAmount")}</th>
            <th className="vat-breakdown-th text-end">{t("grossAmount")}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.rateKey}>
              <td className="vat-breakdown-td">
                {row.rateKey === "none" ? t("none") : `${row.rateKey}%`}
              </td>
              <td className="vat-breakdown-td text-end">{formatMoney(row.net)}</td>
              <td className="vat-breakdown-td text-end">{formatMoney(row.vat)}</td>
              <td className="vat-breakdown-td text-end">{formatMoney(row.gross)}</td>
            </tr>
          ))}
          <tr className="vat-breakdown-total">
            <td className="vat-breakdown-td poppins-semibold">{t("totalSum")}</td>
            <td className="vat-breakdown-td text-end poppins-semibold">
              {formatMoney(totals.net)}
            </td>
            <td className="vat-breakdown-td text-end poppins-semibold">
              {formatMoney(totals.vat)}
            </td>
            <td className="vat-breakdown-td text-end poppins-semibold">
              {formatMoney(totals.gross)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default VatBreakdown;
